/* eslint-disable no-unused-vars */
import { useState, useCallback, useRef } from 'react';

const useRerender = () => {
  const [, setState] = useState(0);
  return useCallback(() => setState((state) => state + 1), []);
};

export const useFacade = (initialDataArr = []) => {
  const [stateSet, setState] = useState(() => new Set(initialDataArr));
  const state = [...stateSet.values()];
  const rerender = useRerender();
  const changesFlag = useRef(false);

  const isActive = useCallback(
    (fieldName) => {
      return stateSet.has(fieldName);
    },
    [stateSet],
  );

  const toggle = useCallback(
    (...stateItems) => {
      changesFlag.current = true;
      stateItems.forEach((stateItem) => {
        return isActive(stateItem) ? stateSet.delete(stateItem) : stateSet.add(stateItem);
      });
      rerender();
    },
    [isActive, stateSet],
  );

  const toggleOn = useCallback(
    (...stateItems) => toggle(...stateItems.filter((stateItem) => !stateSet.has(stateItem))),
    [toggle],
  );
  const toggleOff = useCallback(
    (...stateItems) => toggle(...stateItems.filter((stateItem) => stateSet.has(stateItem))),
    [toggle],
  );

  return { state, isActive, toggle, toggleOn, toggleOff, setState, changesFlag };
};
